/**
 * 이니시스 본인인증
 */
export default class Inicis {
    constructor() {
    }

    /**
     * 이니니스 인증 팝업 띄우기
     */
    auth(opts){
        let successUrl = opts['successUrl'];
        let failUrl = opts['failUrl'];
        const type = opts['type'];

        $.ajax({
            url: `/m/ajax/inicis/start?type=${type}`,
            type: 'GET',
            success: function (r) {
                let win = (function(){
                    let _width = 400;
                    let _height = 620;
                    var xPos = (document.body.offsetWidth/2) - (_width/2); // 가운데 정렬
                    xPos += window.screenLeft; // 듀얼 모니터일 때

                    return window.open("", "sa_popup", "width="+_width+", height="+_height+", left="+xPos+", menubar=yes, status=yes, titlebar=yes, resizable=yes");
                })();

                if (win != undefined && win != null) {

                    // 기존 폼이 있다면 제거
                    const existingForm = document.getElementById('saForm');
                    if (existingForm) {
                        existingForm.remove();
                    }

                    // samesite 쿠키는 도저히 믿을수 없어서 파라미터에 값을 전달
                    successUrl+='?k='+encodeURIComponent(r.k);
                    failUrl+='?k='+encodeURIComponent(r.k);
                    // console.log(successUrl);

                    let targetUrl = 'https://sa.inicis.com/auth';
                    if( G5['inicisByPass']==1 ) {// 인증 무시하도록 설정되어있는 경우
                        targetUrl = successUrl;
                    }

                    // Create form using jQuery
                    const $form = $('<form>', {
                        id: 'saForm',
                        name: 'saForm',
                        method: 'POST',
                        action: targetUrl,
                        target: 'sa_popup'
                    });

                    // Add hidden inputs
                    const formData = {
                        successUrl: successUrl,
                        failUrl: failUrl,
                        mid: r.mid,
                        reqSvcCd: r.reqSvcCd,
                        mTxId: r.mTxId,
                        authHash: r.authHash,
                        flgFixedUser: r.flgFixedUser,
                        userHash: '',
                        reservedMsg: r.reservedMsg
                    };

                    // Add each hidden input using jQuery
                    $.each(formData, function (key, value) {
                        $form.append($('<input>', {
                            type: 'hidden',
                            name: key,
                            value: value
                        }));
                    });

                    // Append form to body and submit
                    $form.appendTo('body').submit();

                }
            }
        });
    }
}